import React from 'react';
import './AboutIntro.scss';

const AboutIntro = () => {
  return (
    <section className="about-intro section">
      <div className="container">
        <div className="grid grid--2-cols">
          <div className="about-intro__column">
            <div className="about-intro__icon about-intro__icon--article">
              {/* Article icon will be added as background image */}
            </div>
            <h2 className="about-intro__title">
              Skil.AI's powerful virtual assistants
            </h2>
            <p className="about-intro__text">
              Skil.AI's powerful virtual assistants are designed to support businesses and customers instantly and reliably. From sending emails to booking appointments, handling payroll, managing inventory, dealing with customer service, and much more, your virtual assistant can take care of a huge variety of tasks and business functions for you, automatically and adaptably.
            </p>
          </div>

          <div className="about-intro__column">
            <div className="about-intro__icon about-intro__icon--tech">
              {/* Tech icon will be added as background image */}
            </div>
            <h2 className="about-intro__title">
              Industry-leading omni-channel support
            </h2>
            <p className="about-intro__text">
              With industry-leading omni-channel support, multi-language capabilities, and voice-recognition as standard, your new intelligent digital employee will have the power to truly transform the way you manage your workflow.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutIntro; 
